import s from "./Home.module.scss";
import MainPhoto from "../../Components/MainPhoto/MainPhoto";
import MainText from "../../Components/MainText/MainText";
import InformationBlock from "../../Components/InformationBlock/InformationBlock";
import Footer from "../../Components/Footer/Footer";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useRef } from "react";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import CountriesButtons from "../../Components/CountriesButtons/CountriesButtons";
import Header from "../../Components/Header/Header";
import { Seo } from "../../Seo";

const Home = () => {
  const { width } = useWindowDimensions();

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
      <Seo
        title="Твой маршрут"
        description="ИНФОРМАЦИЯ О ВИЧ, ТУБЕРКУЛЕЗЕ, СИФИЛИСЕ И ПОДДЕРЖКЕ ЗА РУБЕЖОМ ДЛЯ
      ТРУДЯЩИХСЯ МИГРАНТОВ И ЧЛЕНОВ ИХ СЕМЕЙ"
        url="https://www.vputi.org"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}

        <MainPhoto />
        {/* <MainText /> */}
        <div style={{ marginTop: "50px", marginBottom: "50px" }}>
          <CountriesButtons />
        </div>
        <MainText />
      </div>
      <InformationBlock />
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Home;
